import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { deleteUser as deleteUserAction } from "@/redux/user/user.action";
import { Typography } from "@mui/material";
import { Trash } from "lucide-react";
import { useState } from "react";
import { useAppDispatch } from "@/redux/hooks";
import { allUsers as fetchAllUsers } from "@/redux/user/user.action";
import { SuccessToast } from "@/utilities/toasts/SuccessToast";
import { ErrorToast } from "@/utilities/toasts/ErrorToast";

interface DeleteDialogProps {
  userId: string;
}

const DeleteDialog = ({ userId }: DeleteDialogProps) => {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const handleDelete = async () => {
    try {
      const response = await dispatch(deleteUserAction(userId));
      if (response.type.endsWith("/fulfilled")) {
        SuccessToast({ message: "Usuario eliminado correctamente" });
        await dispatch(fetchAllUsers());
        setOpen(false);
      } else {
        ErrorToast({ message: "Error al eliminar el usuario" });
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      ErrorToast({ message: "Error al eliminar el usuario" });
    }
  };
  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger>
        <Button className="h-8 w-8 p-0 hover:bg-gray-200 hover:text-red-500 rounded-full">
          <Trash className="h-4 w-4" />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-sidebar max-w-[35rem]">
        <AlertDialogHeader>
          <AlertDialogTitle>
            <Typography fontFamily={"Inter"} fontSize={"18px"} fontWeight={500}>
              Estás seguro que quieres eliminar este usuario?
            </Typography>
          </AlertDialogTitle>
          <AlertDialogDescription>
            <Typography
              fontFamily={"Inter"}
              fontSize={"14px"}
              fontWeight={400}
              color={"#666666"}
            >
              Esta acción no se puede deshacer. Este usuario será eliminado
              permanentemente y sus datos serán eliminados de nuestros
              servidores.
            </Typography>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="cancel" onClick={() => setOpen(false)}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            className="bg-red-500 hover:bg-red-600 shadow-sm"
            onClick={handleDelete}
          >
            Eliminar
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteDialog;
